import { FC, Fragment, JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { AddRounded as AddRoundedIcon } from '@mui/icons-material';
// components
import SandCoatingTable from './SandCoatingTable';
// constant, styles, reducer, graphql
import { flexCenterBetween } from 'styles/commonComponentStyle';
import { ADD_NEW_TEXT, ADD_SAND_COATING_ROUTE, SAND_COATING_TEXT } from 'constants/index';

const SandCoating: FC = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{SAND_COATING_TEXT}</Typography>
        <Button variant="contained" color="primary" onClick={() => navigate(ADD_SAND_COATING_ROUTE)}>
          <AddRoundedIcon />
          {ADD_NEW_TEXT}
        </Button>
      </Box>
      <SandCoatingTable />
    </Fragment>
  );
};

export default SandCoating;
